import { useEffect, useLayoutEffect, useRef } from 'react';
import { useBlocker } from 'react-router';
import usePreventLeaving from './usePreventLeaving';
import { useAppDispatch } from '../app/redux/useAppSelector';
import ConfirmationModal from '../components/ConfirmationModal';
import { UIActions } from '../ui/uiSlice';

const useBeforeRouterLeaveConfirmWithModal = ({
  skip,
  onConfirm,
  title,
  cancelButtonText,
  confirmButtonText,
  message,
}: {
  skip?: boolean;
  onConfirm(): Promise<void>;
  cancelButtonText?: string;
  confirmButtonText?: string;
  message?: React.ReactNode;
  title: string;
}) => {
  const onConfirmRef = useRef(onConfirm);
  useLayoutEffect(() => {
    onConfirmRef.current = onConfirm;
  });

  const dispatch = useAppDispatch();

  usePreventLeaving({ skip });
  const blocker = useBlocker(!skip);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      dispatch(
        UIActions.openModal(ConfirmationModal, {
          title,
          message,
          cancelButtonText,
          confirmButtonText,
          close() {
            dispatch(UIActions.closeModal());
            blocker.proceed?.();
          },
          onConfirm: onConfirmRef.current,
        }),
      );
    }
  }, [blocker, cancelButtonText, confirmButtonText, dispatch, message, title]);
};

export default useBeforeRouterLeaveConfirmWithModal;
